import { ChangeEvent, FocusEvent, useRef } from 'react'

import { useScrollToOnFocus } from 'utils'
import cn from 'classnames'

import './styles.scss'

export interface Props extends Omit<React.HTMLProps<HTMLTextAreaElement>, 'onChange' | 'onInput'> {
  onChange?: (value: string) => void
  onInput?: (value: string) => void
  scrollToOnFocus?: boolean
}

export const TextArea = (props: Props) => {
  const { onInput, onChange, onFocus, onBlur, value, label, className, scrollToOnFocus, ...rest } =
    props

  const ref = useRef<HTMLTextAreaElement>(null)

  const { onFocus: onHookFocus, onBlur: onHookBlur } = useScrollToOnFocus(ref, scrollToOnFocus)

  const onChangeHandler = (e: ChangeEvent<HTMLTextAreaElement>) => onChange?.(e.target.value)
  const onInputHandler = (e: ChangeEvent<HTMLTextAreaElement>) => onInput?.(e.target.value)
  const onFocusHandler = (e: FocusEvent<HTMLTextAreaElement>) => {
    onHookFocus()
    onFocus?.(e)
  }
  const onBlurHandler = (e: FocusEvent<HTMLTextAreaElement>) => {
    onHookBlur()
    onBlur?.(e)
  }

  const baseJsx = (
    <textarea
      {...rest}
      ref={ref}
      value={value || ''}
      className="textarea form-input"
      onChange={onChangeHandler}
      onInput={onInputHandler}
      onFocus={onFocusHandler}
      onBlur={onBlurHandler}
    />
  )

  return (
    <div className={cn('form-input-wrapper', className)}>
      {label ? (
        <label className="form-label">
          <span className="input-label">{label}</span>
          {baseJsx}
        </label>
      ) : (
        baseJsx
      )}
    </div>
  )
}
